import React, { useEffect, useState } from "react";

import { useNavigate } from 'react-router-dom';
import API from "common-ui-components/components/utils/API";
import { formatDdMmm } from "common-ui-components/components/utils/dateUtils";

const useProcessOverviewData = (
  managedDevice,
  totalUsers,
  totalSoftware,
  prohibitedSoftware,
  nonCompliance,
  getTrend = true,
) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    devices: [],
    users: [],
    softwares: [],
    prohibitedSoftwares: [],
    commercialSoftwaresTrend: [],
    nonCommercialSoftwaresTrend: [],
    prohibitedSoftwaresTrend: [],
  });

  useEffect(() => {
    const processData = (data) => {
      const devices = [];
      const users = [];
      const softwares = [];
      const prohibitedSoftwares = [];
      const commercialSoftwaresTrend = [];
      const nonCommercialSoftwaresTrend = [];
      const prohibitedSoftwaresTrend = [];
      const done = [];
      data.forEach((item, index) => {
        const date = formatDdMmm(item.date);
        const today = formatDdMmm(new Date()) === date;
        if (done.includes(date)) return;
        done.push(date);
        devices.push({
          x: date,
          y: item.managedDeviceCount,
          label: "Devices",
          color: false,
        });
        users.push({
          x: date,
          y: item.managedUserCount,
          label: "Users",
          color: false,
        });
        commercialSoftwaresTrend.push({
          x: date,
          y: item.commercialSoftwareCount,
          label: "Commercial",
          color: true,
        });
        nonCommercialSoftwaresTrend.push({
          x: date,
          y: item.nonCommercialSoftwareCount,
          label: "Non Commercial",
          color: true,
        });
        prohibitedSoftwaresTrend.push({
          x: date,
          y: item.prohibitedSoftwareCount,
          label: "Prohibited",
          color: true,
        });
        softwares.push({
          id: date,
          label: date,
          value: item.installedSoftwareCount,
          color: today ? "#d5b33b" : "#e8e7e0",
        });
        prohibitedSoftwares.push({
          id: date,
          label: date,
          value: item.prohibitedSoftwareCount || 0,
          color: today ? "#f26553" : "#e8e7e0",
        });
      });
      setData({
        devices,
        users,
        softwares,
        prohibitedSoftwares,
        commercialSoftwaresTrend,
        nonCommercialSoftwaresTrend,
        prohibitedSoftwaresTrend,
      });
    };
    const getTrends = async () => {
      try {
        const response = await API.get("/inventory/getTrends");
        if (response.status.success) processData(response.body);
        else console.error(response.status.message);
      } catch (error) {
        console.error(error);
      }
    };
    if (getTrend) getTrends();
  }, []);

  return {
    overviewCardsData: [
      {
        heading: "Managed Devices",
        count: managedDevice,
        percent: 10,
        increased: true,
        graphData: [
          {
            id: "Devices",
            color: "#00a165",
            data: data.devices,
          },
        ],
        graphType: "line",
        accentColor: "#00a165",
        handleCardClick: () => navigate("../devices"),
      },
      {
        heading: "Users",
        count: totalUsers,
        percent: 10,
        increased: false,
        graphData: [
          {
            id: "Users",
            color: "#4698cf",
            data: data.users,
          },
        ],
        graphType: "line",
        accentColor: "#4698cf",
      },
      {
        heading: "Software",
        count: totalSoftware,
        percent: 10,
        increased: true,
        graphType: "bar",
        accentColor: "#d5b33b",
        graphData: data.softwares,
        handleCardClick: () => navigate("../apps"),
      },
      {
        heading: "Prohibited Software",
        count: prohibitedSoftware,
        percent: 10,
        increased: false,
        graphType: "bar",
        accentColor: "#f26553",
        graphData: data.prohibitedSoftwares,
        handleCardClick: () =>
          navigate(
            "../apps?inventory-apps=%7B%22columns%22%3A%5B%5D%2C%22sort%22%3A%7B%7D%2C%22search%22%3A%5B%5D%2C%22filter%22%3A%5B%7B%22column%22%3A%22access_type%22%2C%22filterValue%22%3A2%7D%5D%7D",
          ),
      },
      {
        heading: "Devices Non-Compliant",
        count: nonCompliance || 0,
        accentColor: "#e52b20",
        content: () => <span style={{ color: "#64748b", fontSize: "0.85rem" }}>Policy evaluation result</span>,
      },
    ],
    softwareTypeTrendData: {
      "Non Commercial Software": data.nonCommercialSoftwaresTrend,
      "Commercial Software": data.commercialSoftwaresTrend,
      "Prohibited Software": data.prohibitedSoftwaresTrend,
    },
  };
};

export default useProcessOverviewData;
